export default __webpack_public_path__ + "static/05.03-92a827857e7eb15795268cd2c628b42a.png";